import { render, staticRenderFns } from "./TheoryExamList.vue?vue&type=template&id=3d85da9a&scoped=true&"
import script from "./TheoryExamList.vue?vue&type=script&lang=ts&"
export * from "./TheoryExamList.vue?vue&type=script&lang=ts&"
import style0 from "./TheoryExamList.vue?vue&type=style&index=0&id=3d85da9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d85da9a",
  null
  
)

export default component.exports